import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from './header'
import Menu from './menu'
class Results extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }
    render() {
        return (
            <body className="radheexch">
                <Header notify={this.props.notify} subscribe={(type, id)=>{this.props.subscribe(type, id)}} subscriptions={this.props.subscriptions} history = {this.props.history} socket={this.props.socket} />
                <div className="wrapper">
                <Menu history = {this.props.history}  subscribe={(type, id)=>{this.props.subscribe(type, id)}} subscriptions={this.props.subscriptions}  />
                    <div className="content-page ">
                        <span style={{ color: "red" }}>This is only Layout Design of Page.</span>
                        <div className="l-flex main-menu-box">
                            <div className="l-fg3">
                                <div className="main-menu-play">
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="menu-title">Results</div>
                                        </div>
                                    </div>
                                    <div className="row mt-3 results-page">
                                        <div className="col-12 col-sm-12 col-md-3">
                                            <div className="form-group mb-0">
                                                <label for="exampleFormControlSelect1">From Date:</label>
                                                <input className="form-control" type="date" id="FromDate" />
                                                <span id="rfvOldPassword" className="error">Reqired</span>
                                            </div>
                                        </div>
                                        <div className="col-12 col-sm-12 col-md-3">
                                            <div className="form-group mb-0">
                                                <label for="exampleFormControlSelect1">To Date:</label>
                                                <input className="form-control" type="date" id="ToDate" />
                                                <span id="rfvOldPassword" className="error">Reqired</span>
                                            </div>
                                        </div>
                                        <div className="col-12 col-sm-12 col-md-3">
                                            <label for="exampleFormControlSelect1">Select Game:</label>
                                            <select className="form-control" id="sel1">
                                                <option>Cricket</option>
                                                <option>Soccer</option>
                                                <option>Tennis</option>
                                            </select>
                                        </div>
                                        <div className="col-12 col-sm-12 col-md-3">
                                            <div className="form-group mb-0">
                                                <label for="exampleFormControlSelect1">&nbsp;</label>
                                                <button className="float-left place-bet-btn mar-top ">Search</button>
                                            </div>
                                        </div>
                                        <div className="col-12 col-sm-12 col-md-12 mt-4">
                                            <div className="dt-responsive table-responsive account-statment">
                                                <table id="basic-btn" className="table table-striped table-bordered nowrap table-sm  ">
                                                    <thead>
                                                        <tr className="bg-dark text-white">
                                                            <th>S.No</th>
                                                            <th>Event Date/Time</th>
                                                            <th>Event Name</th>
                                                            <th>Home</th>
                                                            <th>Away</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>1</td>
                                                            <td>3/17/2020 12:00:00 AM</td>
                                                            <td>
                                                                <span className="text-success">South Africa T5</span> v
                                                                <span className="text-danger">West Indies T5</span>
                                                                <span>( +5 Markets )</span>
                                                            </td>
                                                            <td>53/0</td>
                                                            <td>52/3</td>
                                                        </tr>
                                                        <tr>
                                                            <td>2</td>
                                                            <td>3/17/2020 12:00:00 AM</td>
                                                            <td>
                                                                <span className="text-success">South Africa T5</span> v
                                                                <span className="text-danger">West Indies T5</span>
                                                                <span>( +5 Markets )</span>
                                                            </td>
                                                            <td>53/0</td>
                                                            <td>52/3</td>
                                                        </tr>
                                                        <tr>
                                                            <td>3</td>
                                                            <td>3/17/2020 12:00:00 AM</td>
                                                            <td>
                                                                <span className="text-success">South Africa T5</span> v
                                                                <span className="text-danger">West Indies T5</span>
                                                                <span>( +5 Markets )</span>
                                                            </td>
                                                            <td>53/0</td>
                                                            <td>52/3</td>
                                                        </tr>
                                                        <tr>
                                                            <td>4</td>
                                                            <td>3/17/2020 12:00:00 AM</td>
                                                            <td>
                                                                <span className="text-success">South Africa T5</span> v
                                                                <span className="text-danger">West Indies T5</span>
                                                                <span>( +5 Markets )</span>
                                                            </td>
                                                            <td>53/0</td>
                                                            <td>52/3</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </body>
        )
    }
}

function mapStateToProps(state) {
    return {
    };
}

function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(Results);